// ────────────────────────────────────────────────────────────
// FILES — read-only list (legacy shell)
// ────────────────────────────────────────────────────────────
// Upload and extraction were removed with the ingestion boundary:
// documents enter through the pipeline only (crawler, ingest queue,
// manual R2 inbox). This list just shows what a deal has and opens
// the bytes from R2.

import type { DealFile, FileKind } from '../../types';
import { filesApi } from '../../services/api';

const KIND_LABEL: Record<FileKind, string> = {
  pdf: 'PDF', img: 'IMG', txt: 'TXT', docx: 'DOC', other: 'FIL',
};

interface Props { dealId: string; files: DealFile[]; }

export function FilesList({ files }: Props) {
  return (
    <>
      <div className="col-section">
        <span className="col-section-title">Files · {files.length}</span>
      </div>

      <div className="files-list">
        {files.length === 0 && (
          <div className="empty-state" style={{ padding: '14px 22px', textAlign: 'left' }}>
            Documents arrive through the pipeline; none on this deal yet
          </div>
        )}
        {files.map(f => (
          <div key={f.id} className={`file-item ${f.isHighlighted ? 'highlighted' : ''}`}>
            <a
              className={`file-icon ${f.kind}`}
              href={f.blobKey ? filesApi.downloadUrl(f.id) : undefined}
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >{KIND_LABEL[f.kind]}</a>
            <div style={{ minWidth: 0 }}>
              <div className="file-name">{f.name}</div>
              <div className="file-meta">{f.summary || <em>no summary</em>}</div>
            </div>
            <span className={`file-source ${f.source}`}>
              {f.source === 'cowork' ? 'Clerk' :
               f.source === 'idoc'   ? 'IDoc'  :
               f.source === 'close'  ? 'Close' :
               f.source === 'email'  ? 'Email' :
               f.source === 'text'   ? 'Text'  :
               'Upload'}
            </span>
          </div>
        ))}
      </div>
    </>
  );
}
